import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getTaskTags, createTaskTag, updateTaskTags } from 'api/taskTags/'
import { notifyError, notifySuccess } from 'ui/components/Notify'

export const getTaskTagsAction = createAsyncThunk(
  'taskTags/getTaskTags',
  async () => {
    return await getTaskTags()
  }
)

export const createTaskTagAction = createAsyncThunk(
  'taskTags/createTaskTag',
  async ({ data }) => {
    return await createTaskTag(data)
  }
)

export const updateTaskTagsAction = createAsyncThunk(
  'taskTags/updateTaskTags',
  async ({ id, data }) => {
    return await updateTaskTags(id, data)
  }
)

const taskTagsSlice = createSlice({
  name: 'taskTags',
  initialState: {
    list: [],
    newTags: [],
    status: 'idle',
    error: null,
  },
  reducers: {
    addNewTaskTag: (state, action) => {
      state.newTags.push(action.payload)
    },
    deleteNewTaskTag: (state, action) => {
      state.newTags = state.newTags.filter((tag) => tag.id !== action.payload)
    },
    resetNewTaskTag: (state) => {
      state.newTags = []
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTaskTagsAction.pending, (state) => {
        state.status = 'pending'
      })
      .addCase(getTaskTagsAction.fulfilled, (state, action) => {
        state.list = action.payload.data || []
        state.status = 'idle'
      })
    builder
      .addCase(createTaskTagAction.pending, (state) => {
        state.status = 'pending'
      })
      .addCase(createTaskTagAction.fulfilled, (state, action) => {
        if (action.payload?.data?.errors) {
          state.status = 'error'
        } else {
          state.status = 'idle'
        }
      })
    builder
      .addCase(updateTaskTagsAction.pending, (state) => {
        state.status = 'pending'
      })
      .addCase(updateTaskTagsAction.fulfilled, (state, action) => {
        if (action.payload?.data?.errors) {
          notifyError(action.payload.data.message)
          state.status = 'error'
        } else {
          state.list = state.list.map((tag) =>
            tag.id === action.payload?.data?.id ? action.payload.data : tag
          )
          state.status = 'idle'
          notifySuccess('Тег успешно обновлён')
        }
      })
  },
})

export const tagsListSelector = (state) => state.taskTags.list
export const newTagsSelector = (state) => state.taskTags.newTags

export const { addNewTaskTag, deleteNewTaskTag, resetNewTaskTag } =
  taskTagsSlice.actions

export default taskTagsSlice.reducer
